<template>
  <div>
    <div class="row">
      <div class="col-4"></div>
      <div class="col-8">
        <div class="yandex-map-opener">
          <a href="#" @click.prevent="open = !open">Уточнить на карте</a>
        </div>
      </div>
    </div>
    <div
      :class="{'yandex-map-container--open': open}"
      class="yandex-map-container">
      <tc-input
        class="mt-1"
        :label-text="'Координаты'"
        v-model="coordsString"
      />
      <yandex-map
        :coords="mapCoord"
        :placemarks="placemarks"
        zoom="14"
        style="width: 100%; height: 400px;"
        map-type="map"
        @map-was-initialized="initHandler">
      </yandex-map>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import TcInput from './TcInput'
import { yandexGeoCodeApiKey } from '../../../config'

export default {
  name: 'TcMap',
  props: {
    value: {
      type: String,
      default: '55.751242, 37.620686'
    },
    cityId: {
      type: Number,
      default: 1
    },
    address: {
      type: String,
      default: ''
    }
  },
  components: {
    TcInput
  },
  watch: {
    cityId: function () {
      this.stopTimeout()
      setTimeout(() => { // Ограничение кол-ва запросов
        this.setMapCoordsByAddress()
      }, 800)
    },
    address: function () {
      this.stopTimeout()
      setTimeout(() => { // Ограничение кол-ва запросов
        this.setMapCoordsByAddress()
      }, 2000)
    },
    coordsString: function () {
      this.setMapCoordsString()
    }
  },
  computed: {
    ...mapState({
      cities: state => state.globalStore.cities
    })
  },
  data () {
    return {
      placemarks: [
        {
          coords: [55.751242, 37.620686],
          options: { draggable: true },
          callbacks: { dragend: this.setNewCoord }
        }
      ],
      mapObj: {},
      mapCoord: [55.751242, 37.620686],
      open: false,
      coordsString: '55.751242, 37.620686'
    }
  },
  methods: {
    initHandler (obj) {
      this.mapObj = obj
      this.getCameraCoords(this.mapObj)
    },
    setNewCoord (e) {
      let thisPlacemark = e.get('target')
      let coords = thisPlacemark.geometry.getCoordinates()
      this.coordsString = coords[0] + ', ' + coords[1]
      this.$emit('input', +coords[0] + ', ' + coords[1])
      this.placemarks[0].coords = coords
    },
    setMapCoordsString () {
      this.mapCoord = this.coordsString.split(', ')
      this.placemarks.splice(0, 1, {
        coords: [parseFloat(this.coordsString.split(', ')[0]), parseFloat(this.coordsString.split(', ')[1])],
        options: { draggable: true },
        callbacks: { dragend: this.setNewCoord }
      })
      this.$emit('input', '' + this.coordsString)
    },
    getCameraCoords (map) {
      if (this.placemarks.length === 1) {
        map.setCenter(this.placemarks[0].coords, 14, {
          checkZoomRange: true
        })
      }
    },
    setMapCoordsByAddress () {
      let city
      this.cities.forEach((e) => {
        if (e.id === this.cityId) {
          city = e.name
        }
      })
      let address = this.address
      let url = 'https://geocode-maps.yandex.ru/1.x/?format=json&apikey=' + yandexGeoCodeApiKey + '&sco=latlong&geocode=' + city + ' ' + address
      this.$http.get(url).then((response) => {
        let coords = response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ')
        coords = coords.map((coord) => {
          return parseFloat(coord)
        })
        this.placemarks.splice(0, 1, {
          coords: [coords[1], coords[0]],
          options: { draggable: true },
          callbacks: { dragend: this.setNewCoord }
        })
        this.getCameraCoords(this.mapObj)
        this.coordsString = coords[1] + ', ' + coords[0]
        this.$emit('input', +coords[1] + ', ' + coords[0])
      }).catch((error) => {
        console.log(error)
        this.addToast({
          text: 'Ошибка при загрузке карты: ' + error,
          type: 'danger',
          dismissAfter: 3000
        })
      })
    },
    stopTimeout () {
      let id = window.setTimeout(null, 0)
      while (id--) {
        window.clearTimeout(id)
      }
    },
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    })
  },
  created () {
    this.placemarks[0].coords[0] = parseFloat(this.value.split(', ')[0])
    this.placemarks[0].coords[1] = parseFloat(this.value.split(', ')[1])
    this.coordsString = this.value
  }
}
</script>

<style scoped lang="scss">
.yandex-map {
  &-opener {

  }

  &-container {
    overflow: hidden;
    transition: 0.8s;
    max-height: 0;

    &--open {
      max-height: 400px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// TcMap.vue?091a01bd